import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit, Inject } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { environment } from 'src/environments/environment';
import { ModalpopService } from '../modalpop.service';
import { UmsService } from '../ums.service';

@Component({
  selector: 'app-regn-exam-sub',
  templateUrl: './regn-exam-sub.component.html',
  styleUrls: ['./regn-exam-sub.component.scss']
})
export class RegnExamSubComponent implements OnInit {
  APIService: any;
  subGrid: any;

  constructor(
    public umsService: UmsService,
    private modalPopupService: ModalpopService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,   public router: Router,  private httpClient: HttpClient,
   private spinner: NgxSpinnerService,
   private dialogRef2:MatDialogRef<RegnExamSubComponent>,
   private dialog: MatDialog,
     ) { this.APIService = environment.serviceUrl; }

  ngOnInit(): void {
    this.subGrid = []
    if(this.data.type == 'exam'){
      this.SubData(this.data)
    }
    else if(this.data.type == 'All'){
      this.SubAll(this.data.data)
    }
    
  }

  SubAll(data){
    this.subGrid = []
    this.spinner.show();
    const payload = {};
    payload['RgId'] = data.RgId
    payload['RsEmId'] = 0
    this.umsService.SearchRegnSub(payload).subscribe((res) => {
      this.spinner.hide();
      this.subGrid = res.data;
    
    },(ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      this.subGrid = []
    })
  }

  SubData(data){
    this.subGrid = []
    this.spinner.show();
    const payload = {};
    payload['RgId'] = data.data[0].ReRgId
    payload['RsEmId'] = data.data[0].ReEmId
    this.umsService.SearchRegnSub(payload).subscribe((res) => {
      this.spinner.hide();
      this.subGrid = res.data;
    
    },(ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      this.subGrid = []
    })
  }

  
}
